<template>
  <TableLayout :permissions="['business:banner:query']">
    <!-- 搜索表单 -->
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:banner:create', 'business:banner:delete']">
        <li><el-button type="primary" @click="$refs.operaBannerWindow.open('新建专区产品')" icon="el-icon-plus" v-permissions="['business:banner:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="imgurlfull" label="专区展示图" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-image v-if="!!row.imgFullUrl" :src="row.imgFullUrl" style="width: 100px; height: 60px;" :previewSrcList="[row.imgFullUrl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="parentName" label="专区名称" align="center" min-width="140px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsNum" label="关联产品数" align="center" min-width="100px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sortnum" label="排序码(升序)" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center" min-width="140px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:banner:update', 'business:banner:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
          align="center"
        >
          <template slot-scope="{row}">
            <el-button
              type="text"
              @click="$refs.operaBannerWindow.open('编辑专区产品', row)"
              v-permissions="['business:banner:update']"
            >编辑</el-button>
            <el-button
              type="text"
              style="color: red;"
              @click="deleteById(row)"
              v-permissions="['business:banner:delete']"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaBannerWindow ref="operaBannerWindow" @success="handlePageChange"/>

  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaBannerWindow from '@/components/business/OperaBannerZhuanquWindow'
export default {
  name: 'Banner',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaBannerWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        position: 3
      },
    }
  },
  created () {
    this.config({
      module: '轮播图信息表',
      api: '/business/banner',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
}
</script>
